// extracted by mini-css-extract-plugin
module.exports = {"avatar-container":"avatar_collection__avatar-container___3_TeD"};